import { render } from "./TemplateFieldConfig.vue?vue&type=template&id=0d63f47c&scoped=true"
import script from "./TemplateFieldConfig.vue?vue&type=script&lang=js"
export * from "./TemplateFieldConfig.vue?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d63f47c"]])

export default __exports__